import React from "react";
import { Clock, Truck, PackageCheck, AlertTriangle } from "lucide-react";

const STEPS = [
  { key: "pending", label: "Pendiente", icon: Clock },
  { key: "in_transit", label: "En tránsito", icon: Truck },
  { key: "delivered", label: "Entregado", icon: PackageCheck },
];

export function ShipmentProgress({ status, compact = false }) {
  if (status === "exception") {
    return (
      <div data-testid="shipment-progress" className="flex items-center gap-2 text-red-600 border border-red-300 bg-red-50 px-3 py-2 text-sm font-bold uppercase tracking-wide">
        <AlertTriangle className="w-4 h-4" /> Incidencia en el envío
      </div>
    );
  }
  const idx = STEPS.findIndex((s) => s.key === status);
  const current = idx === -1 ? 0 : idx;
  const dot = compact ? "w-6 h-6" : "w-9 h-9";
  const iconSz = compact ? "w-3.5 h-3.5" : "w-5 h-5";

  return (
    <div data-testid="shipment-progress" className="flex items-center w-full">
      {STEPS.map((step, i) => {
        const done = i < current;
        const active = i === current;
        const Icon = step.icon;
        return (
          <React.Fragment key={step.key}>
            <div className="flex flex-col items-center gap-1 shrink-0" data-testid={`progress-step-${step.key}`}>
              <div className={`${dot} rounded-full flex items-center justify-center border-2 transition-colors ${
                done ? "bg-emerald-500 border-emerald-500 text-white"
                  : active ? "bg-freight border-freight text-black"
                  : "bg-muted border-border text-muted-foreground"
              }`}>
                <Icon className={iconSz} strokeWidth={2.4} />
              </div>
              {!compact && (
                <span className={`text-[10px] font-bold uppercase tracking-wide ${active ? "text-freight" : done ? "text-emerald-600" : "text-muted-foreground"}`}>
                  {step.label}
                </span>
              )}
            </div>
            {i < STEPS.length - 1 && (
              <div className={`flex-1 h-1 mx-1 ${compact ? "mb-0" : "mb-5"} ${i < current ? "bg-emerald-500" : "bg-border"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default ShipmentProgress;
